(function () {
  const ZAPIET_SELECTOR =
    '#storePickupApp, .zapiet-widget, [class*="zapiet"], [id*="Zapiet"], [id*="zapiet"]';
  const DEBOUNCE_MS = 120;

  let scrollTimer;

  function isCartDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    return Boolean(drawer && drawer.classList.contains('active'));
  }

  function scrollCartDrawerToBottom() {
    if (!isCartDrawerOpen()) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    const zapietNodes = cartDrawer.querySelectorAll(ZAPIET_SELECTOR);
    const footer = cartDrawer.querySelector('.drawer__footer');

    zapietNodes.forEach(function (node) {
      if (node.scrollHeight > node.clientHeight) {
        node.scrollTop = node.scrollHeight;
      }
    });

    const scrollTarget = zapietNodes.length ? zapietNodes[zapietNodes.length - 1] : footer;

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }

    if (drawerInner && drawerInner.scrollHeight > drawerInner.clientHeight) {
      drawerInner.scrollTo({ top: drawerInner.scrollHeight, behavior: 'smooth' });
    }
  }

  function scheduleScroll() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(scrollCartDrawerToBottom, DEBOUNCE_MS);
  }

  function observeNode(node) {
    if (!node || node.dataset.agrotropicZapietObserved === 'true') return;

    node.dataset.agrotropicZapietObserved = 'true';

    new MutationObserver(scheduleScroll).observe(node, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });
  }

  function setupCartDrawerObserver() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.dataset.agrotropicZapietSetup === 'true') return;

    cartDrawer.dataset.agrotropicZapietSetup = 'true';
    observeNode(cartDrawer);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            scheduleScroll();
          }
        }
      });

      cartDrawer.querySelectorAll(ZAPIET_SELECTOR).forEach(observeNode);
      scheduleScroll();
    }).observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    cartDrawer.querySelectorAll(ZAPIET_SELECTOR).forEach(observeNode);
  }

  function init() {
    setupCartDrawerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
(function () {
  const ZAPIET_SELECTOR =
    '#storePickupApp, .zapiet-widget, [class*="zapiet"], [id*="Zapiet"], [id*="zapiet"]';
  const DEBOUNCE_MS = 120;

  let scrollTimer;

  function isCartDrawerOpen() {
    const drawer = document.querySelector('cart-drawer');
    return Boolean(drawer && drawer.classList.contains('active'));
  }

  function scrollCartDrawerToBottom() {
    if (!isCartDrawerOpen()) return;

    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer) return;

    const drawerInner = cartDrawer.querySelector('.drawer__inner');
    const zapietNodes = cartDrawer.querySelectorAll(ZAPIET_SELECTOR);
    const footer = cartDrawer.querySelector('.drawer__footer');

    zapietNodes.forEach(function (node) {
      if (node.scrollHeight > node.clientHeight) {
        node.scrollTop = node.scrollHeight;
      }
    });

    const scrollTarget = zapietNodes.length ? zapietNodes[zapietNodes.length - 1] : footer;

    if (scrollTarget) {
      scrollTarget.scrollIntoView({ block: 'end', behavior: 'smooth' });
    }

    if (drawerInner && drawerInner.scrollHeight > drawerInner.clientHeight) {
      drawerInner.scrollTo({ top: drawerInner.scrollHeight, behavior: 'smooth' });
    }
  }

  function scheduleScroll() {
    clearTimeout(scrollTimer);
    scrollTimer = setTimeout(scrollCartDrawerToBottom, DEBOUNCE_MS);
  }

  function observeNode(node) {
    if (!node || node.dataset.agrotropicZapietObserved === 'true') return;

    node.dataset.agrotropicZapietObserved = 'true';

    new MutationObserver(scheduleScroll).observe(node, {
      childList: true,
      subtree: true,
      attributes: true,
      characterData: true,
    });
  }

  function setupCartDrawerObserver() {
    const cartDrawer = document.querySelector('cart-drawer');
    if (!cartDrawer || cartDrawer.dataset.agrotropicZapietSetup === 'true') return;

    cartDrawer.dataset.agrotropicZapietSetup = 'true';
    observeNode(cartDrawer);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
          if (cartDrawer.classList.contains('active')) {
            scheduleScroll();
          }
        }
      });

      cartDrawer.querySelectorAll(ZAPIET_SELECTOR).forEach(observeNode);
      scheduleScroll();
    }).observe(cartDrawer, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class'],
    });

    cartDrawer.querySelectorAll(ZAPIET_SELECTOR).forEach(observeNode);
  }

  function init() {
    setupCartDrawerObserver();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', init);
})();
